"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _uuid = require("uuid");

var _useTheme = _interopRequireDefault(require("../useTheme"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var DxcRadio = function DxcRadio(_ref) {
  var label = _ref.label,
      checked = _ref.checked,
      onClick = _ref.onClick,
      error = _ref.error,
      disabled = _ref.disabled,
      focused = _ref.focused,
      readonly = _ref.readonly,
      tabIndex = _ref.tabIndex;

  var _useState = (0, _react.useState)("radio-".concat((0, _uuid.v4)())),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 1),
      radioLabelId = _useState2[0];

  var ref = (0, _react.useRef)(null);
  var colorsTheme = (0, _useTheme["default"])();

  var handleOnClick = function handleOnClick() {
    var _ref$current;

    onClick();
    document.activeElement !== (ref === null || ref === void 0 ? void 0 : ref.current) && (ref === null || ref === void 0 ? void 0 : (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.focus());
  };

  var _useState3 = (0, _react.useState)(true),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      firstUpdate = _useState4[0],
      setFirstUpdate = _useState4[1];

  (0, _react.useLayoutEffect)(function () {
    var _ref$current2;

    // Don't apply in the first render
    if (firstUpdate) {
      setFirstUpdate(false);
      return;
    }

    focused && (ref === null || ref === void 0 ? void 0 : (_ref$current2 = ref.current) === null || _ref$current2 === void 0 ? void 0 : _ref$current2.focus());
  }, [focused]);
  return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
    theme: colorsTheme.radioGroup
  }, /*#__PURE__*/_react["default"].createElement(RadioMainContainer, null, /*#__PURE__*/_react["default"].createElement(RadioContainer, {
    error: error,
    disabled: disabled,
    readonly: readonly,
    onClick: disabled ? undefined : handleOnClick
  }, /*#__PURE__*/_react["default"].createElement(RadioInputContainer, null, /*#__PURE__*/_react["default"].createElement(RadioInput, {
    error: error,
    disabled: disabled,
    readonly: readonly,
    role: "radio",
    "aria-checked": checked,
    "aria-disabled": disabled,
    "aria-labelledby": radioLabelId,
    tabIndex: disabled ? -1 : focused ? tabIndex : -1,
    ref: ref
  }, checked && /*#__PURE__*/_react["default"].createElement(Dot, {
    disabled: disabled,
    readonly: readonly,
    error: error
  }))), /*#__PURE__*/_react["default"].createElement(Label, {
    id: radioLabelId,
    disabled: disabled
  }, label))));
};

var getRadioInputStateColor = function getRadioInputStateColor(props, state) {
  switch (state) {
    case "enabled":
      return props.disabled ? props.theme.disabledRadioInputColor : props.error ? props.theme.errorRadioInputColor : props.readonly ? props.theme.readonlyRadioInputColor : props.theme.radioInputColor;

    case "hover":
      return props.error ? props.theme.hoverErrorRadioInputColor : props.readonly ? props.theme.hoverReadonlyRadioInputColor : props.theme.hoverRadioInputColor;

    case "active":
      return props.error ? props.theme.activeErrorRadioInputColor : props.readonly ? props.theme.activeReadonlyRadioInputColor : props.theme.activeRadioInputColor;
  }
};

var RadioMainContainer = _styledComponents["default"].div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n"])));

var RadioInputContainer = _styledComponents["default"].span(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 24px;\n  width: 24px;\n"])));

var RadioInput = _styledComponents["default"].span(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n  box-sizing: border-box;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 18px;\n  height: 18px;\n  border: 2px solid ", ";\n  border-radius: 50%;\n\n  &:focus {\n    outline: 2px solid ", ";\n    outline-offset: 1px;\n  }\n  ", "\n"])), function (props) {
  return getRadioInputStateColor(props, "enabled");
}, function (props) {
  return props.theme.focusBorderColor;
}, function (props) {
  return props.disabled && "pointer-events: none;";
});

var Dot = _styledComponents["default"].span(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n  height: 10px;\n  width: 10px;\n  border-radius: 50%;\n  background-color: ", ";\n"])), function (props) {
  return getRadioInputStateColor(props, "enabled");
});

var Label = _styledComponents["default"].span(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2["default"])(["\n  margin-left: ", ";\n  font-family: ", ";\n  font-size: ", ";\n  font-style: ", ";\n  font-weight: ", ";\n  line-height: ", ";\n  ", "\n"])), function (props) {
  return props.theme.radioInputLabelMargin;
}, function (props) {
  return props.theme.fontFamily;
}, function (props) {
  return props.theme.radioInputLabelFontSize;
}, function (props) {
  return props.theme.radioInputLabelFontStyle;
}, function (props) {
  return props.theme.radioInputLabelFontWeight;
}, function (props) {
  return props.theme.radioInputLabelLineHeight;
}, function (props) {
  return props.disabled ? "color: ".concat(props.theme.disabledRadioInputLabelFontColor, ";") : "color: ".concat(props.theme.radioInputLabelFontColor);
});

var RadioContainer = _styledComponents["default"].span(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2["default"])(["\n  display: inline-flex;\n  align-items: center;\n  cursor: ", ";\n\n  &:hover {\n    ", " {\n      border-color: ", ";\n    }\n    ", " {\n      background-color: ", ";\n    }\n  }\n  &:active {\n    ", " {\n      border-color: ", ";\n    }\n    ", " {\n      background-color: ", ";\n    }\n  }\n"])), function (props) {
  return props.disabled ? "not-allowed" : props.readonly ? "default" : "pointer";
}, RadioInput, function (props) {
  return !props.disabled && getRadioInputStateColor(props, "hover");
}, Dot, function (props) {
  return !props.disabled && getRadioInputStateColor(props, "hover");
}, RadioInput, function (props) {
  return !props.disabled && getRadioInputStateColor(props, "active");
}, Dot, function (props) {
  return !props.disabled && getRadioInputStateColor(props, "active");
});

var _default = /*#__PURE__*/_react["default"].memo(DxcRadio);

exports["default"] = _default;